
export default {
  name: 'DialogCentered',

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 668,
    },
    header: {
      type: String,
      default: '',
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    overlayColor: {
      type: String,
      default: 'primary darken-1',
    },
  },

  data() {
    return {
      dialog: this.isShown,
    };
  },

  watch: {
    isShown(value) {
      this.dialog = value;
    },
  },
};
